import styled from 'styled-components'

export const Select = styled.div`
  height: 5rem;
  & > label {
    height: 5rem;
    max-height: 5rem;
    border: 1px solid #c2c7d6 !important;
    box-shadow: none !important;

    &::placeholder {
      color: #a3abc2;
    }

    &:hover {
      border: 1px solid #c2c7d6 !important;
      box-shadow: inset 0 0 0 1px #c2c7d6 !important;
    }

    &:active,
    &:focus {
      border-color: #3a64f8;
      box-shadow: none;
    }
  }

  & > div {
    width: 28rem;
  }

  div[class^='OptionGroupstyled__StyledOptionGroup'] {
    padding: 0 5px;
  }

  div[class^='Optionstyled__StyledOption'] {
    border-radius: 3px;
  }

  div[class^='Popupstyled__ContentWrapper'] {
    box-shadow: 0 4px 20px 0 #525c7a26;
  }

  @media (max-width: 1279px) {
    & > div {
      width: 23rem;
    }
  }
`
